import {connect} from 'react-redux';

import {makeGetCellsContent} from '../../../../../../srcCommon/inboxes/cells/cellsConversationsSelectors';
import {makeMapStateToProps} from '../../../../../helpers/reselectHelpers';
import {AppState} from '../../../../../store/appState';
import {CellsPanelConversationsPageState} from '../../../../../store/panels/cells/cellsPanelState';
import {CellsConversationsConversations} from './cellsConversationsConversations';

/*
 * Props.
 */

interface CellsConversationsConversationsContainerProps {
  page: CellsPanelConversationsPageState;
}

/*
 * Selectors.
 */

function getPage(_state: AppState, props: CellsConversationsConversationsContainerProps) {
  return props.page;
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<CellsConversationsConversationsContainerProps>()(() => ({
  content: makeGetCellsContent(getPage),
}));

export const CellsConversationsConversationsContainer = connect(mapStateToProps)(
  CellsConversationsConversations,
);
